/**
 * 优惠券接口协议
 * @author chenhang06
 */

export interface ICouponCard {
  clickUrl: string; // 优惠券点击跳转链接
  couponId: number;
  couponStatus: number; // 优惠券状态 0-已失效，1-已领取待使用，2-已使用
  couponValue: number; // 优惠券价值 单位分
  desc: string[];
  endTime: string; // 优惠券失效时间
  icon: string;
  orderAvailable: boolean; // 优惠券是否本单可用
  startTime: string; // 优惠券领取时间
  title: string; // 优惠券名称
  type: number; // 优惠券类型
  minOrderAmount: number; // 优惠券使用门槛 单位分
  doctorIds: number[];
  doctorNames: string[];
  receiveTime: string; // 优惠券领取时间
  couponCategoryId: number;
}

export interface ICouponListData {
  lastMark: boolean;
  pageNum: number;
  pageSize: number;
  total: number;
  list: ICouponCard[];
}

export interface ICouponListQuery {
  couponStatus?: number; // 优惠券状态
  orderDoctorId?: number; // 订单医生id
  orderPrice?: number; // 订单价格 单位分
  orderType?: number; // 订单类型
  pageNum: number;
  pageSize: number;
  sortRules: number; // 排序规则
}

export interface ICouponPopupQuery {
  activityCodeList?: string[];
  doctorId?: number;
  showLoading?: boolean;
  actionType?: number; // 0-仅查询（活动页传参），1-查询并领取系统自动发放类优惠券（首页传参）
}
export interface ICouponPopUpDataItem {
  activityCode: string; // 活动码
  activityDesc: string[];
  coupons: IPopupCouponDataItem[]; // 活动内优惠券列表
  priority: number; // 活动优先级
  department: string; // 医生科室
  doctorAvatar: string; // 医生头像
  doctorName: string; // 医生姓名
  endTime: number;
  startTime: number;
  status: number; // 活动状态，0-活动未开始，1-可领取，2-已领取，3-不可领取，4-活动已结束
}

export interface IPopupCouponDataItem {
  clickUrl: string; // 优惠券点击跳转链接
  couponId: number;
  couponValue: number; // 优惠券价值 单位分
  desc: string[];
  doctorIds: number[];
  doctorNames: string[];
  endTime: string; // 优惠券失效时间
  icon: string;
  startTime: string; // 优惠券领取时间
  title: string; // 优惠券名称
  type: number; // 优惠券类型
  minOrderAmount: number; // 优惠券使用门槛 单位分
  status: ACTIVITY_STATUS;
}

export interface IReceiveCouponQuery {
  activityCode: string;
  doctorId?: number;
}
export enum CouponStatus {
  EXPIRED = 4, // 已过期
  UNUSED = 1, // 未使用
  USED = 3 // 已使用
}
export enum SORTRULES {
  END_TIME = 1, // 按过期时间排序
  AVAILABLE_AND_PRICE = 2, // 本单可用且优惠最大
  RECEIVE_TIME = 3 // 领取时间
}

export enum COUPON_TYPE {
  FREE_COUPON = 1, // 免单券
  LIMIT_VOUCHER = 2 // 满减券
}

// 优惠券数据与tabbar对应关系
export enum COUPON_DATA_MAP {
  unusedList,
  usedList,
  expiredList
}

// 活动状态
export enum ACTIVITY_STATUS {
  UNSTART, // 活动未开始
  UNCLAIMED, // 待领取
  RECEIVED, // 已领取
  FORBID, // 不可领取
  END, // 活动已结束
  NOT_TO_EXIST // 领完
}

export enum ACTION_TYPE {
  ONLYSEARCH, // 仅查询 活动页
  AUTO_RECEIVE //  查询并领取系统自动发放类优惠券 首页配置这个参数
}
